<template>
    <div>
        <router-view></router-view>
        <loading></loading>
        <div class="show" v-if="hasOpenModal"></div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Loading from '@/components/Loading.vue';
import { anyModalOpen, installModalKeyboardHandling } from './plugins/modalStore';
// import axios from "axios";

export default {
    name: 'AppPage',
    data() {
        return {
        }
    },
    mounted() {
        this.getConfigurationData();
    },
    created() {
        this.setTenantTheme();
        installModalKeyboardHandling();
    },
    components: { Loading },
    computed: {
        ...mapGetters("config", ["configuration"]),
        hasOpenModal() {
            return anyModalOpen();
        },
    },
    watch: {
        hasOpenModal(isOpen) {
            document.body.classList.toggle('modal-open', isOpen);
        },
    },
    methods: {
        ...mapActions("config", ["getConfigurationData"]),
        setTenantTheme() {
            // Mirrors main.js's existing hostname -> theme-file selection,
            // as a native Tailwind CSS-variable tenant instead of loading a
            // separate ~100KB stylesheet per tenant (see [data-tenant] rules
            // in src/assets/css/tailwind.css).
            const hostname = location.hostname;
            let tenant = 'admin';
            if (hostname.includes('nextravel.com.mx') || hostname === '192.168.0.10' || hostname === '192.168.0.14' || hostname === 'localhost') {
                tenant = 'blue';
            } else if (hostname.includes('aliht.com.mx')) {
                tenant = 'blue';
            } else {
                tenant = 'yellow';
            }
            document.documentElement.setAttribute('data-tenant', tenant);
        },
    }
}
</script>